import React, { useEffect, useState } from "react";
import { Accordion, Card, Badge, Form, Spinner } from "react-bootstrap";
import { FaChevronDown, FaSearch, FaExternalLinkAlt } from "react-icons/fa";
import { MdOutlineMenuOpen } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import debounce from "lodash.debounce";
import { IoIosAddCircleOutline } from "react-icons/io";
import { FaqDeleteApi, getfaqApi, getfaqTagsApi } from "../../services/Faq";
import { useCallback } from "react";
import { useSelector } from "react-redux";
import { Dropdown } from "react-bootstrap";
import { MdOutlineEditNote } from "react-icons/md";
import { FaRegTrashAlt } from "react-icons/fa";
import { IoIosWarning } from "react-icons/io";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { toast } from "react-toastify";
function renderDescription(steps) {
  return (
    <div className="faq-steps-layout">
      {steps.map((step, index) => (
        <p key={index}>
          <span className="text-darker fw-medium me-1">Step {index + 1}:-</span>
          <span className="text-dark">{step}</span>
        </p>
      ))}

      {/* RIGHT: Step images */}
      {/* <div className="faq-steps-images">
        {steps.map((step, idx) => (
          <div key={idx} className="faq-step-image">
            <img src={step.image} alt={step.title} />
            <small>{step.title}</small>
            {idx !== steps.length - 1 && (
              <div className="image-arrow text-center">
                <FaArrowDown />
              </div>
            )}
          </div>
        ))}
      </div> */}
      {/* HORIZONTAL Step Images */}
      {/* <div className="faq-steps-images-horizontal">
        {steps.map((step, idx) => {
          if (!step?.image) return null;

          return (
            <React.Fragment key={idx}>
              <div className="faq-step-image">
                <img src={step.image} alt={step.title || "Step"} />
                <small>{step.title}</small>
              </div>

              {idx !== steps.length - 1 && (
                <div className="image-arrow">
                  <FaArrowRight />
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div> */}
    </div>
  );
}
function renderLinks(link) {
  return (
    <div className="d-flex flex-wrap gap-2 mt-3">
      <span className="text-dark fw-medium" style={{ fontSize: "0.8rem" }}>
        Click here:
      </span>
      {link.map((item, index) => (
        <Link
          key={index}
          to={item?.url}
          className="text-primary text-decoration-underline fw-medium fs-6"
          style={{ cursor: "pointer" }}
        >
          {item?.name || "-"}
        </Link>
      ))}
    </div>
  );
}

const Faq = () => {
  const navigate = useNavigate();
  const role = useSelector((state) => state.auth.user?.role || "user");
  const [searchItem, setSearchItem] = useState("");
  const [activeKey, setActiveKey] = useState(null);
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deleteloading, setDeleteLoading] = useState(false);
  const [error, setError] = useState("");
  const [faqs, setFaqs] = useState([]);
  const [selecetdFaq, setSelecetdFaq] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [param, setParam] = useState({
    query: "",
  });

  const handleDeleteDialog = () => {
    if (deleteDialog) {
      setSelecetdFaq(null);
    }
    setDeleteDialog(!deleteDialog);
  };

  const getData = () => {
    setLoading(true);
    getfaqApi(param)
      .then((res) => {
        setError("");
        setFaqs(res?.data || []);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getTag = () => {
    getfaqTagsApi()
      .then((res) => {
        setTags(res?.data || []);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getTag();
  }, []);

  useEffect(() => {
    getData();
  }, [param]);

  const updateQueryDebounced = useCallback(
    debounce((value) => {
      setParam((prev) => ({ ...prev, query: value }));
    }, 300),
    []
  );

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchItem(value);
    updateQueryDebounced(value);
  };

  const handleTagClick = (tag) => {
    setSearchItem(tag);
    setParam((prev) => ({ ...prev, query: tag }));
  };

  const handleToggle = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };

  const handleMenuToggleClick = (event) => {
    // Prevent the click from bubbling up to Accordion
    event.stopPropagation();
  };

  const handleDelete = () => {
    setDeleteLoading(true);
    FaqDeleteApi(selecetdFaq?.id)
      .then((res) => {
        handleDeleteDialog();
        toast.success("Deleted Successfully");
        getData();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setDeleteLoading(false);
      });
  };
  return (
    <>
      <div className="mb-4 d-flex justify-content-between align-items-center flex-wrap">
        <div>
          <h2 className="text-primary">FAQ</h2>
          <ol className="breadcrumb breadcrumb-arrow mb-0">
            <li className="breadcrumb-item">
              <Link to="/dashboard">Dashboard</Link>
            </li>
            <li className="breadcrumb-item active">FAQ</li>
          </ol>
        </div>
        {role == "ADMIN" && (
          <Link to="/faq-add" className="btn btn-primary align-self-center">
            <IoIosAddCircleOutline className="me-1" size="19" />
            Add
          </Link>
        )}
      </div>
      <div className="faq-container container-fluid card">
        <div className="text-center mb-2">
          <h2 className="mb-0">Frequently Asked Questions</h2>
          <p className="small fst-italic">
            Find answers to common questions about our services and features.
          </p>
        </div>
        <div className="faq-search-bar row">
          <div className="search-wrapper col-md-8 col-lg-6">
            <FaSearch className="search-icon" />
            <input
              className="search-input"
              type="search"
              placeholder="Search FAQs by keyword or tag..."
              value={searchItem}
              onChange={handleSearchChange}
            />
          </div>

          <div className="col-lg-8 tag-badges scroll-container overflow-auto">
            {tags.map((tag) => (
              <span
                key={tag}
                className={`badge ${searchItem === tag ? "active" : ""}`}
                onClick={() => handleTagClick(tag)}
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
        {loading ? (
          <div className="text-center my-3">
            <Spinner animation="border" />
          </div>
        ) : error ? (
          <div className="text-center my-3">
            <span className="text-center text-danger">{error}</span>
          </div>
        ) : faqs.length > 0 ? (
          <Accordion activeKey={activeKey} alwaysOpen className="faq-accordion">
            {faqs.map((faq, index) => {
              const isOpen = activeKey === index.toString();
              return (
                <div
                  key={faq.id}
                  className={`faq-card ${isOpen ? "open" : ""}`}
                >
                  <div
                    className="faq-header d-flex justify-content-between align-items-center"
                    onClick={() => handleToggle(index.toString())}
                  >
                    <div>
                      <h5>{faq.title}</h5>
                      {/* <div className="faq-tags">
                    {faq.tags.map((tag) => (
                      <span
                        className="stylish-transparent-btn btn btn-sm rounded-3"
                        style={{ padding: "0rem 0.5rem" }}
                      >
                        {tag}
                      </span>
                    ))}
                  </div> */}
                    </div>
                    <div className="d-flex gap-2 me-3">
                      {role == "ADMIN" && (
                        <Dropdown onClick={handleMenuToggleClick}>
                          <Dropdown.Toggle
                            as="span"
                            className="no-caret"
                            style={{ cursor: "pointer" }}
                          >
                            <span
                              className="rounded-1 btn btn-outline-light"
                              style={{ padding: "0.2rem 0.4rem" }}
                            >
                              <MdOutlineMenuOpen className="text-dark" />
                            </span>
                          </Dropdown.Toggle>
                          <Dropdown.Menu className="mt-1">
                            <Dropdown.Item
                              onClick={() => navigate(`/faq-edit/${faq.id}`)}
                            >
                              <MdOutlineEditNote className="me-1" />
                              Edit
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                setSelecetdFaq(faq);
                                handleDeleteDialog();
                              }}
                            >
                              <FaRegTrashAlt className="me-1" />
                              Delete
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      )}

                      <span className={`faq-icon ${isOpen ? "rotate" : ""}`}>
                        <FaChevronDown />
                      </span>
                    </div>
                  </div>

                  <Accordion.Collapse eventKey={index.toString()}>
                    <Card.Body>
                      <>
                        {renderDescription(faq.steps)}
                        <div className="p-2 text-bg-info-soft mt-2 position-relative overflow-hidden">
                          <img
                            src={`${process.env.REACT_APP_BASE_URL}${faq.file}`}
                            width="100%"
                            height="auto"
                          />
                        </div>
                        {faq.access_users?.includes(role) &&
                          renderLinks(faq.links)}
                      </>
                    </Card.Body>
                  </Accordion.Collapse>
                </div>
              );
            })}
          </Accordion>
        ) : (
          <div className="text-center my-3">No data found</div>
        )}
      </div>

      <Dialog
        open={deleteDialog}
        onClose={handleDeleteDialog}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            color: "error.main",
            fontWeight: 600,
          }}
        >
          <IoIosWarning className="text-danger" />
          Delete FAQ
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Are you sure you want to <strong>delete this FAQ</strong>? <br />
            Once completed, you{" "}
            <span style={{ color: "#d32f2f", fontWeight: 500 }}>
              cannot undo this action.
            </span>
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={handleDeleteDialog}
            variant="outlined"
            color="inherit"
            disabled={deleteloading}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="error"
            disabled={deleteloading}
            sx={{ minWidth: 110 }}
            onClick={handleDelete}
          >
            {deleteloading && (
              <Spinner animation="border" size="sm" className="me-1" />
            )}
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Faq;
